export default "__VITE_ASSET__B6o$Gkvx__"